module.exports = __webpack_public_path__ + "img/mentions_black.b527fb8c.svg";